import React from "react";

import './Overlay.css';

interface PropsOverlay {
    message: string
}

const Overlay = ({ message }: PropsOverlay) => {

    return (
        <div className="overlay-container">
            <h1>{message}</h1>
            <div className="spinner-grow custom-spinner" role="status">
                <span className="visually-hidden">Cargando...</span>
            </div>
        </div>
    );
}

export default Overlay;